export default __webpack_public_path__ + "static/media/kybcomplete.a8644931.svg";